import ApiClient from "../../../apiClient";
import { BASE_URL, DASHBOARD } from "../../../constant/apiEndPoint";
import CustomMessage from "../../../utils/CustomMessage";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

// export const getCurrentGoldPriceAction = (navigate) => {
//   return (dispatch) => {
//     loadingToggleAction(dispatch, true);
//     ApiClient.get(`${BASE_URL}${DASHBOARD.currentGoldPrice}`, {}, true)
//       .then((response) => {
//         loadingToggleAction(dispatch, false);
//         dispatch({
//           type: TYPE.GET_CURRENT_GOLD_PRICE_SUCCESS,
//           payload: response.data.result,
//         });
//       })
//       .catch((error) => {
//         if (error.status === 419) {
//           CustomToast({
//             type: "error",
//             message: "Session expired, please login again",
//             options: { autoClose: 5000, position: "top-center" },
//           });
//           checkSession(dispatch, navigate);
//           return;
//         }
//         loadingToggleAction(dispatch, false);
//         dispatch({
//           type: TYPE.GET_CURRENT_GOLD_PRICE_FAIL,
//           payload: CustomMessage(error.status),
//         });
//         CustomToast({
//           type: "error",
//           message: CustomMessage(error.status),
//           options: { autoClose: 5000, position: "top-center" },
//         });
//       });
//   };
// };

export const getCurrentGoldPriceAction = () => {
  return ApiClient.get(`${BASE_URL}${DASHBOARD.currentGoldPrice}`, {}, true)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      return error;
    });
};

export const getHistoricalGoldPriceAction = (payload) => {
  return ApiClient.post(`${BASE_URL}${DASHBOARD.historicalGoldPrice}`, payload, true)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};

export const getAllActiveCustomerAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${DASHBOARD.totalUsers}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);

        dispatch({
          type: TYPE.GET_TOTAL_ACTIVE_CUSTOMER_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_TOTAL_ACTIVE_CUSTOMER_FAIL,
          payload: CustomMessage(error.status),
        });
        CustomToast({
          type: "error",
          // message: CustomMessage(error.status),
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const getTotalSalesAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${DASHBOARD.totalSales}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);

        dispatch({
          type: TYPE.GET_TOTAL_SALES_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        if (error.status === 419) {
          // CustomToast({
          //   type: "error",
          //   message: "Session expired, please login again",
          //   options: { autoClose: 5000, position: "top-center" },
          // });
          checkSession(dispatch, navigate);
          return;
        }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_TOTAL_SALES_FAIL,
          payload: CustomMessage(error.status),
        });
        // CustomToast({
        //   type: "error",
        //   message: CustomMessage(error.status),
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getRewardReceivedAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${DASHBOARD.totalrewardReceived}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_REWARD_RECEIVED_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     // options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_REWARD_RECEIVED_FAIL,
          payload: CustomMessage(error.status),
        });
        // CustomToast({
        //   type: "error",
        //   message: CustomMessage(error.status),
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getRewardRedemedAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${DASHBOARD.totalrewardRedeemption}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);

        dispatch({
          type: TYPE.GET_REWARD_REDEEM_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     // options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_REWARD_REDEEM_FAIL,
          payload: CustomMessage(error.status),
        });
        // CustomToast({
        //   type: "error",
        //   message: CustomMessage(error.status),
        //   // options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getRecentCustomersAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${DASHBOARD.recentCustomers}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);

        dispatch({
          type: TYPE.GET_RECENT_CUSTOMERS_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     // options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_RECENT_CUSTOMERS_FAIL,
          payload: CustomMessage(error.status),
        });
        // CustomToast({
        //   type: "error",
        //   message: CustomMessage(error.status),
        //   // options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getRecentTransactionsAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${DASHBOARD.recentTransaction}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_RECENT_TRANSACTION_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        //debugger;
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     // options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_RECENT_TRANSACTION_FAIL,
          payload: CustomMessage(error.status),
        });
        // CustomToast({
        //   type: "error",
        //   message: CustomMessage(error.status),
        //   // options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getSalesHistoryAction = (payload) => {
  return ApiClient.post(`${BASE_URL}${DASHBOARD.SALES_HISTORY}`, payload, true)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};
